/* sdp-announce.js — tiny evergreen MM:SS countdown for the top bar, plus the
   sticky bar's hide-while-the-CTA-target-is-on-screen behaviour.
   Reads data-sdp-minutes off each [data-sdp-countdown]; on reaching 0 it
   resets to the start (evergreen). No dependencies; multi-instance safe. */
(function () {
  'use strict';

  var HIDDEN_CLASS = 'sdp-announce-is-hidden';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function format(totalSeconds) {
    var m = Math.floor(totalSeconds / 60);
    var s = totalSeconds % 60;
    return pad(m) + ':' + pad(s);
  }

  function startCountdown(el) {
    var minutes = parseInt(el.getAttribute('data-sdp-minutes'), 10);
    if (isNaN(minutes) || minutes <= 0) {
      minutes = 15;
    }
    var start = minutes * 60;
    var remaining = start;

    el.textContent = format(remaining);

    setInterval(function () {
      remaining -= 1;
      if (remaining < 0) {
        remaining = start; // evergreen reset
      }
      el.textContent = format(remaining);
    }, 1000);
  }

  /* The sticky rule sits on the Shopify section wrapper, so that is what gets
     the hidden class — not the inner bar. */
  function stickyHost(bar) {
    if (!bar.closest) {
      return bar;
    }
    return bar.closest('.shopify-section') || bar;
  }

  /* A bottom bar is position:fixed, so it leaves no slot in the flow — pad the
     body by its height so the last bit of page content stays reachable. */
  function bindBottomOffset(bar) {
    var mobile = bar.getAttribute('data-sdp-sticky-mobile');
    var desktop = bar.getAttribute('data-sdp-sticky-desktop');
    if (mobile !== 'bottom' && desktop !== 'bottom') {
      return;
    }
    var host = stickyHost(bar);
    var mq = window.matchMedia('(min-width: 1024px)');

    function apply() {
      var mode = mq.matches ? desktop : mobile;
      document.body.style.paddingBottom = mode === 'bottom' ? host.offsetHeight + 'px' : '';
    }

    apply();
    window.addEventListener('resize', apply);
  }

  function bindSticky(bar) {
    var selector = bar.getAttribute('data-sdp-hide-target');
    if (!selector || selector.charAt(0) !== '#' || selector.length < 2) {
      return; // full URLs and empty anchors have nothing to observe
    }
    if (!('IntersectionObserver' in window)) {
      return; // bar simply stays visible
    }

    var target;
    try {
      target = document.querySelector(selector);
    } catch (e) {
      return; // malformed selector typed into the anchor field
    }
    if (!target) {
      return;
    }

    var host = stickyHost(bar);
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          host.classList.add(HIDDEN_CLASS);
        } else {
          host.classList.remove(HIDDEN_CLASS);
        }
      }
    }, { threshold: 0 });

    observer.observe(target);
  }

  /* Guard so a theme-editor re-render never stacks a second interval or
     observer onto nodes that survived the swap. */
  function each(root, selector, fn) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-sdp-bound') === 'true') {
        continue;
      }
      nodes[i].setAttribute('data-sdp-bound', 'true');
      fn(nodes[i]);
    }
  }

  function init(root) {
    var scope = root || document;
    each(scope, '[data-sdp-countdown]', startCountdown);
    each(scope, '[data-sdp-sticky]', function (bar) {
      bindBottomOffset(bar);
      bindSticky(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
